import { IAction } from "src/store";
import { augmentReducer } from "src/store/utils";
import { getPreviousState } from "src/shared/utils";
import { DetailActionsConstants, detailsReducer, filtersReducer, tableChartsReducer } from "./redux";
import { DetailsReducerState } from "./types";

export const initialState = {
  filters: getPreviousState("metricDetails.filters") || {},
  selectedTab: getPreviousState("app.selectedTab") || "Today",
  selectedDimensions: (getPreviousState("metricDetails.selectedDimensions") || []) as string[],
  pinning: {
    open: true,
  },
};

const detailsParentReducer = (state = initialState, { type, payload }: IAction<symbol, any>) => {
  switch (type) {
    case DetailActionsConstants.get("SET_DETAILS_FILTERS"):
      return {
        ...state,
        filters: payload,
      };
    case DetailActionsConstants.get("SET_DIMENSIONS"):
      return { ...state, selectedDimensions: payload };
    default:
      return state;
  }
};

export default augmentReducer<DetailsReducerState, IAction<symbol, any>>(detailsParentReducer)({
  charts: detailsReducer,
  distributedFilters: filtersReducer,
  tableCharts: tableChartsReducer,
});
